export default __webpack_public_path__ + "static/media/1886.3935939c.png";